import { BusinessUnit, ReportType, Series } from '@cambridgeassessment/lib-ee-commons';
import React, { useEffect, useState } from 'react';
import { Report } from '../../../types/Series';
import ReportFC from './ReportFC';
import { downloadFromUrl } from '../../../util/downloadHandler';
import { getUnsubmittedReportDownloadLink } from '../../../service/series/reporter';

interface Props {
  type: ReportType;
  report: Report;
  index: number;
  businessUnitId: BusinessUnit['id'];
  series: {
    id: Series['id'];
    name: Series['name'];
  };
  isBeingGenerated: boolean;
  reportLinkText?: string;
}

const ReportFCUnsubmitted: React.FC<Props> = (props) => {
  const { businessUnitId, series, type } = props;
  const [downloadLink, setDownloadLink] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    async function getDownloadLink() {
      const url = await getUnsubmittedReportDownloadLink(businessUnitId, series.id, type);
      setDownloadLink(url || null);
    }

    void getDownloadLink();
  }, [businessUnitId, series.id, type]);

  const onReportLinkClick = (): void => {
    if (downloadLink) {
      downloadFromUrl(downloadLink);
    }
  };

  return (
    <ReportFC
      {...props}
      isBeingGenerated={downloadLink === undefined}
      onClick={onReportLinkClick}
      hideLink={!downloadLink}
    />
  );
};

export default ReportFCUnsubmitted;
